import React from "react";
import { FaLinkedin, FaGithub, FaTwitter, FaEnvelope } from "react-icons/fa";
import "./Footer.css";

const Footer = () => {
  return (
    <section className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <ul className="social-list">
            <li className="socials-ico">
              <a href="https://www.linkedin.com/in/martha-mwau-5b84ab239/">
                <FaLinkedin />
              </a>
            </li>
            <li className="socials-ico">
              <a href="https://github.com/MarsMwau">
                <FaGithub />
              </a>
            </li>
            <li className="socials-ico">
              <a href="mailto:marthamwau16@gmail.com">
                <FaEnvelope />
              </a>
            </li>

            <li className="socials-ico">
              <a href="https://twitter.com/MumbuaMwau">
                <FaTwitter />
              </a>
            </li>
          </ul>
          <p>@2024 created with <span role="img" aria-label="heart" className="pulse"> ❤️ </span> by Martha Mwau.</p>
        </div>
      </div>
    </section>
  );
};

export default Footer;
